import { type CSSObject } from '@emotion/react';
import { useTheme } from '../../../theme';

type Return = Record<'container' | 'button' | 'iconWrapper', CSSObject>;

export const useInfoIconStyles = (): Return => {
  const theme = useTheme();

  return {
    container: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
    button: {
      display: 'inline-flex',
      width: 20,
      height: 20,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      flexShrink: 0,
      cursor: 'pointer',

      padding: 0,
      border: `none`,
      backgroundColor: 'transparent',
      borderRadius: theme.shape.radius100,

      '&:focus-visible': {
        outline: `1px solid ${theme.border.interactive.defaultFocused}`,
        outlineOffset: -1,
      },
    },

    iconWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      width: 18,
      height: 18,
      border: `1px solid ${theme.infoIcon.border}`,
      backgroundColor: theme.infoIcon.base,
      borderRadius: theme.shape.radius100,
      boxShadow: theme.typography.inputShadow,
    },
  };
};
